import { UPDATE_OPTION, UPDATE_MODAL_OPTION } from './constants';

export function updateOption(option) {
  return {
    type: UPDATE_OPTION,
    option,
  };
}

export function updateModalOption(option) {
  return {
    type: UPDATE_MODAL_OPTION,
    option,
  };
}
